/**
 * Context e hook di autenticazione.
 *
 * Separati dal provider (`AuthProvider.tsx`) perché un modulo che esporta sia
 * componenti sia funzioni rompe il Fast Refresh di Vite: a ogni modifica del
 * provider si perderebbe lo stato dell'app in sviluppo.
 */

import { createContext, useContext } from 'react';
import type { LoginPayload, RegisterPayload, User } from './api';

export type AuthContextValue = {
  user: User | null;
  /** `true` finché il tentativo di ripristino della sessione non è concluso. */
  isInitializing: boolean;
  isAuthenticated: boolean;
  login: (payload: LoginPayload) => Promise<void>;
  register: (payload: RegisterPayload) => Promise<void>;
  logout: () => Promise<void>;
};

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth deve essere usato dentro <AuthProvider>');
  }
  return context;
}
